/**
 * @author wuhao
 * 门诊模块；包含病历模块，处方模块，非处方项目
 */
import { getOutpatientAllDetailApi, editCaseDiagnosisApi, editPrescriptionApi, removePrescriptionApi, historyDoor, getOtherProjectApi, saveOrderApi, getOutpatientDetailApi, copyAllHistoryApi, deleteAllDiaApi, copyOutpatientOrderApi, caseDiagnosisApi, getPanel, getDoorPage, getPanelCount, getRegisterPanelList, getPanelListCensus, achievement, getOftenDecoction, saveOftenDecoction, getOftenUsage } from "@/api/outpatientDetail.js";
import { searchProperty } from '@/api/drug'
import { isNull } from "@/utils/validateBase";
import { Message } from 'element-ui';
class Outpatient {
    //门诊总接口
    static outPatientAll(obj) {
            return new Promise((resolve, reject) => {
                getOutpatientAllDetailApi(obj).then(res => {
                    //判断是否填写过门诊单
                    let isUpdate = { isNewCase: false, isNewProject: false };
                    if (res.code == 200) {
                        let data = res.data
                        isUpdate.data = res.data
                            //判断病历和处方模块那部分需要更新
                        if (_.isEmpty(data.orderCaseDiagnosis)) {
                            isUpdate.isNewCase = true
                        }
                        if (_.isEmpty(data.projectRecipes)) {
                            isUpdate.isNewProject = true
                        }
                        resolve(isUpdate)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }
        /**
         * 编辑病历
         */
    static editCaseDiagnosis(obj) {
            return new Promise((resolve, reject) => {
                editCaseDiagnosisApi(obj).then(res => {
                    if (res.code == 200) {
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }
        /**
         * 编辑处方
         */
    static editPrescription(obj) {
            obj.recipeSourceType = isNull(obj.recipeSourceType) ? '0' : obj.recipeSourceType
            return new Promise((resolve, reject) => {
                editPrescriptionApi(obj).then(res => {
                    if (res.code == 200) {
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //删除处方
    static removePrescription(obj) {
            return new Promise((resolve, reject) => {
                removePrescriptionApi(obj).then(res => {
                    if (res.code == 200) {
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //获取处方中药品库存
    static getInventory(obj) {
            return new Promise((resolve, reject) => {
                    searchProperty(obj).then(res => {
                        if (res.code == 200) {
                            resolve(res)
                        }
                    }).catch(err => {
                        reject(err)
                    })
                })
                // return new Promise((resolve, reject) => {
                //     getInventoryApi(obj).then(res => {
                //         if (res.code == 200) {
                //             resolve(res)
                //         }
                //     }).catch(err=>{
                //         reject(err)
                //     })
                // })
        }
        //搜索药品
    static getOtherProject(obj) {
        return new Promise((resolve, reject) => {
            getOtherProjectApi(obj).then(res => {
                if (res.code == 200) {
                    let data = res.data;
                    let options = []
                    if (!_.isEmpty(data.drugs)) {
                        let drugs = data.drugs.map(val => {
                            return {
                              ...val,
                              itemId: val.spuId,
                              itemName: val.spuCommonName,
                              itemUnit: val.unit,
                              doseType: val.firstCategory ,
                              isOwned: '0',
                              price:Number(val.price)
                            }
                        })
                        options = options.concat(drugs)
                    }
                    if (!_.isEmpty(data.physioInfos)) {
                        let physio = data.physioInfos.map(val => {
                            return {
                                itemId: val.spuId,
                                itemName: val.spuCommonName,
                                price: val.price,
                                itemUnit: '次'
                            }
                        })
                        options = options.concat(physio)
                    }
                    resolve(options)
                }
            }).catch(err => {
                reject(err)
            })
        })
    }


    //完成接诊
    static saveOrder(obj) {
            return new Promise((resolve, reject) => {
                saveOrderApi(obj).then(res => {
                    if (res.code == 200) {
                        resolve(res)
                    }else{
                      reject(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //完成接诊
    static getOutpatientDetail(obj) {
            return new Promise((resolve, reject) => {
                getOutpatientDetailApi(obj).then(res => {
                    if (res.code == 200) {
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //保存全部历史就诊信息
    static copyAllHistory(obj) {
            return new Promise((resolve, reject) => {
                copyAllHistoryApi(obj).then(res => {
                    if (res.code == 200) {
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //保存全部历史就诊信息
    static deleteAllDia(obj) {
            return new Promise((resolve, reject) => {
                deleteAllDiaApi(obj).then(res => {
                    if (res.code == 200) {
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }

    static copyOutpatientOrder(obj) {
      return new Promise((resolve, reject) => {
        copyOutpatientOrderApi(obj).then(res => {
          if (res.code == 200) {
            resolve(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
        //保存全部历史就诊信息
    static caseDiagnosis(obj) {
            return new Promise((resolve, reject) => {
                caseDiagnosisApi(obj).then(res => {
                    if (res.code == 200) {
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //获取门诊看板统计信息
    static getPanel(obj) {
            return new Promise((resolve, reject) => {
                getPanel(obj).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //获取门诊看板分页查询信息
    static getDoorPage(obj) {
            return new Promise((resolve, reject) => {
                getDoorPage(obj).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //获取挂号看板数量
    static getPanelCount(obj) {
            return new Promise((resolve, reject) => {
                getPanelCount(obj).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //获取挂号看板list
    static getRegisterPanelList(obj) {
            return new Promise((resolve, reject) => {
                getRegisterPanelList(obj).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //获取挂号看板list统计
    static getPanelListCensus(obj) {
            return new Promise((resolve, reject) => {
                getPanelListCensus(obj).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
        // 业绩明细
    static achievement(obj) {
            return new Promise((resolve, reject) => {
              achievement(obj).then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
        //查询历史门诊信息  
    static getHistoryDoor(obj) {
        return new Promise((resolve, reject) => {
            historyDoor(obj).then(res => {
                resolve(res)
            }).catch(err => {
                resolve({ code: 500 })
            })
        })
    }

    // 获取医生常用用法
    static async getOftenUsage() {
        const param = {
            doctorId: JSON.parse(sessionStorage.getItem('user')).doctorId
        }
        const res = await getOftenUsage(param)
        if (res.code === 200) {
            return res.data
        } else {
            Message.error(res.msg)
        }
    }

    // 获取常用煎法
    static async getOftenDecoction(spuId = '') {
        const param = {
          spuId: spuId
        }
        const res = await getOftenDecoction(param)
        if (res.code === 200) {
            return res.data
        } else {
            Message.error(res.msg)
        }
    }

    // 保存常用煎法
    static async saveOftenDecoction(spuId = '', handling = '', enable = 1) {
        const param = {
            spuId: spuId,
            handling: handling,
            enable: enable
        }
        const res = await saveOftenDecoction(param)
        if (res.code === 200) {
            return res.data
        } else {
            Message.error(res.msg)
        }
    }

}

export { Outpatient }